import { render } from "./ProjectCreate.vue?vue&type=template&id=82f511ee&scoped=true"
import script from "./ProjectCreate.vue?vue&type=script&lang=js"
export * from "./ProjectCreate.vue?vue&type=script&lang=js"

import "./ProjectCreate.vue?vue&type=style&index=0&id=82f511ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82f511ee"]])

export default __exports__